import React, { Fragment } from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
// import SectionTitle from "../Title";
import SectionTitle from './Title'
// import "./style.scss";
import Category from '../components/Category'
import { t } from 'i18next'

// images
import teamMember1 from '../images/oil/o1.jpeg'
import teamMember2 from '../images/oil/o2.jpeg'
import teamMember3 from '../images/oil/o3.jpeg'
// import teamMember4 from '../images/oil/o4.jpeg'

const teams = [
  {
    // name: "Alecgander Harry",
    name: 'Amazon Lubricants',
    level: '',
    image: teamMember1,
    socialMedia: ['facebook', 'twitter', 'linkedin'],
  },
  {
    name: 'Amazon Lubricants',
    level: '',
    image: teamMember2,
    socialMedia: ['facebook', 'twitter', 'linkedin'],
  },
  {
    name: 'Amazon Lubricants',
    level: '',
    image: teamMember3,
    socialMedia: ['facebook', 'twitter', 'linkedin'],
  },
  //   {
  //     name: 'Amazon Lubricants',
  //     level: '',
  //     image: teamMember4,
  //     socialMedia: ['facebook', 'twitter', 'linkedin'],
  //   },
]

const settings = {
  dots: false,
  infinite: true,
  arrows: true,
  speed: 1000,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
}
const OilSection = ({ className, title, subTitle, slider, noGutters }) => {
  return (
    // <div className={className}>

    <div className="teamArea teamAreaStyleTwo">
      <div className="container">
        {/* <div className={!noGutters ? "row" : "row no-gutters"}> */}
        <div className={!'true' ? 'row' : 'row no-gutters'}>
          <div className="col-12">
            {/* <SectionTitle title={title} subTitle={subTitle} /> */}
            <SectionTitle title="Petrol Engine Oil" subTitle="" />
          </div>
          {/* {slider ? ( */}
          {true ? (
            <div className="col-12">
              <Slider className="teamSlideArea" {...settings}>
                {teams.map((team, i) => (
                  <div key={i} className="teamWrapper">
                    <div className="teamImage">
                      <img src={team.image} alt="" />
                    </div>
                    <div className="teamContent">
                      <h3>{team.name}</h3>
                      <span>{team.level}</span>
                      {/* <ul>
                        {team.socialMedia.map((social) => (
                          <li key={social}>
                            <a href="#">
                              <i
                                className={`fa fa-${social}`}
                                aria-hidden="true"
                              ></i>
                            </a>
                          </li>
                        ))}
                      </ul> */}
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          ) : (
            <Fragment>
              {teams.map((team, i) => (
                <div key={i} className="col-lg-4 col-md-6 col-12">
                  <div className="teamWrapper">
                    <div className="teamImage">
                      <img src={team.image} alt="" />
                    </div>
                    <div className="teamContent">
                      <h3>{team.name}</h3>
                      <span>{team.level}</span>
                      <ul>
                        {team.socialMedia.map((social) => (
                          <li key={social}>
                            <a href="#">
                              <i
                                className={`fa fa-${social}`}
                                aria-hidden="true"
                              ></i>
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </Fragment>
          )}
        </div>
      </div>
    </div>
  )
}
export default OilSection
